import React, { useState, useEffect } from "react";

 const useAudio = url => {
    const [audio, setAudio] = useState(new Audio(url));
    const [playing, setPlaying] = useState({
        status:false,
        url: url,
        sequence: 0
    });
  
    // const [counter, resetCounter] = useState(0);

    const toggle = (data) =>{

      console.log("toggle called", data);

        if(data.sequence > playing.sequence && data.status )
        playSound(data);
    };
  
    const playSound = (playing) => {


      const tempAudio = new Audio(playing.url);

      let counter = 0;

      if(playing.isLoop){
          tempAudio.addEventListener('ended', function(){
              console.log('run again', counter );


              if (counter >= 1) {
                 
                return;
            }

              setTimeout(()=>{
                tempAudio.currentTime = 0;
                tempAudio.play();
            
                counter = counter + 1;
              }, 1000)
          
             
          
           
          });
      }

      setAudio(tempAudio);

      tempAudio.play();

    }
    useEffect(() => {


      },
      [playing]
    );
  
    useEffect(() => {
      audio.addEventListener('ended', () => setPlaying(false));
      return () => {
        audio.removeEventListener('ended', () => setPlaying(false));
      };
    }, []);
  
    return [playing, toggle];
  };

  export default useAudio;